import { Injectable } from '@angular/core'
import { EMPTY, catchError } from 'rxjs'

import { RecordPageAccessGQL } from '../../../_generated/graphql'

@Injectable({ providedIn: 'root' })
export class PageAccessLogService {
  private static readonly THROTTLE_MS = 30_000
  private lastAccessMap = new Map<string, number>()

  constructor(private recordPageAccessGQL: RecordPageAccessGQL) {}

  /** 画面アクセスを記録する。短時間の同一パス連続送信は抑制する。 */
  recordAccess(path: string): void {
    const now = Date.now()
    const lastAccess = this.lastAccessMap.get(path)
    if (lastAccess && now - lastAccess < PageAccessLogService.THROTTLE_MS) {
      return
    }
    this.lastAccessMap.set(path, now)
    this.evictStaleEntries(now)

    this.recordPageAccessGQL
      .mutate({ variables: { path } })
      .pipe(catchError(() => EMPTY))
      .subscribe()
  }

  /** 30秒以上経過したスロットリングエントリを除去する。 */
  private evictStaleEntries(now: number): void {
    for (const [key, timestamp] of this.lastAccessMap) {
      if (now - timestamp >= PageAccessLogService.THROTTLE_MS) {
        this.lastAccessMap.delete(key)
      }
    }
  }
}
